import EventEmitter from 'src/helpers/EventEmitter'
import gsap from 'gsap'
const THREE = require('three') 
import frag from '@/components/stage/shaders/colored_sprite/fragment.glsl'
import vert from '@/components/stage/shaders/base.vert'
import {findWhere} from '@/helpers/ArrayUtils' 
import Communicator from '@/helpers/Communicator'  
import BaseScene from '@/components/stage/common/base_scene' 

const Events = {}

class Sprite extends BaseScene {


  // SETUP - - - - - - - - - - - - - - - - - - - - - - - 

  constructor(config) {

    super(config) 
    Object.assign(this, EventEmitter)
    
    let frames = config.data.frames
    let meta = config.data.meta
    let defaultConfig = {
      transparent : true,
      spritesheet : {
        frames: frames,
        frame_width: frames[0].sourceSize.w,
        frame_height: frames[0].sourceSize.h,
        width: meta.size.w,
        height: meta.size.h 
      } 
    } 

    this.prev_index = -1
    this.fps = 25
    this.config = Object.assign(defaultConfig, config) 
    this.rTexture = new THREE.WebGLRenderTarget( this.config.spritesheet.frame_width, this.config.spritesheet.frame_height, {
      minFilter: THREE.LinearFilter,
      magFilter: THREE.NearestFilter,   
      format: THREE.RGBAFormat  
    })

  
    this.camera = new THREE.OrthographicCamera( this.config.spritesheet.frame_width / - 2, this.config.spritesheet.frame_width / 2, this.config.spritesheet.frame_height / 2, this.config.spritesheet.frame_height / - 2, 0.1, 1000 )
    this.camera.position.z = 2  
    
    this.tweenObj = {
      opacity: 1
    }

    
    this.setup()
    this.resize()   
  } 

  renderScene(){ 
    this.renderer.setRenderTarget(this.rTexture)
    this.renderer.render(this, this.camera) 
  } 

  resize(){}

  setup() {
 
    let frame = this.getFrame(0)
    let rect = frame.spriteSourceSize
 
    let material_options = {

      uniforms: {

        texture: { 
          value: this.config.texture
        },
        opacity: { 
          value: 1.0
        },

        colorEnabled: { 
          value: false
        },
        color: { 
          value: new THREE.Color()
        },


        // SPRITESHEET
        // spritesheet texture width / height
        tSize: { 
          value: new THREE.Vector2(this.config.spritesheet.width, this.config.spritesheet.height)
        },
        // frame trimmed width / height
        fTrimSize: { 
          value: new THREE.Vector2()
        },
        // frame original width / height
        fOriginalSize: { 
          value: new THREE.Vector2(this.config.spritesheet.frame_width, this.config.spritesheet.frame_height)
        },
        // frame x / y offset
        fOffset: { 
          value: new THREE.Vector2()
        },
        fTrimOffset: { 
          value: new THREE.Vector2()
        }

      },
      transparent: this.config.transparent, 
      vertexShader: vert,
      fragmentShader: frag
    }

    this.geometry = new THREE.PlaneBufferGeometry(1 , 1 , 4)
    this.material = new THREE.ShaderMaterial(material_options) 
    this.material.needsUpdate = true
    this.mesh = new THREE.Mesh(this.geometry, this.material ) 
    this.mesh.scale.x = 35
    this.mesh.scale.y = 50
    this.add(this.mesh) 

    this.frame = {
      current: 0,
      loop: 0,
      start: 0,
      end: 0
    }; 
  }
  
  destroy(){ 
    if(this.geometry) this.geometry.dispose()
    if(this.material) this.material.dispose() 
  }

  enter(){ 
  }

  leave(){ 
  }

  killTweens(){
    gsap.killTweensOf(this.frame, { current: true })
  }



  // Movieclip controls

  gotoAndStop(index) { 

    if(this.prev_index === index){
      return
    }

    var f = this.getFrame(index)
    this.material.uniforms.fTrimSize.value.x = f.spriteSourceSize.w
    this.material.uniforms.fTrimSize.value.y = f.spriteSourceSize.h
    this.material.uniforms.fOffset.value.x = (f.frame.x)
    this.material.uniforms.fOffset.value.y = (f.frame.y)
    this.material.uniforms.fTrimOffset.value.x = f.spriteSourceSize.x
    this.material.uniforms.fTrimOffset.value.y = f.spriteSourceSize.y
    this.renderScene()
    this.prev_index = index
  }

  gotoAndPlayRange(gotoFrame, endFrame, onComplete = ()=>{}, speed = 1, delay = 0) {

    if (gotoFrame === null) {
      gotoFrame = this.frame.current;
    }

    this.frame.end = endFrame; //this.getFrameForLabel(endFrame);
    this.frame.start = gotoFrame; // this.getFrameForLabel(gotoFrame); 
    this.frame.count = 0; 
    this.looping = true;

    gsap.killTweensOf(this.frame, { current: true })
    this.frame.current = this.frame.start
 
    var duration = speed * (Math.abs(this.frame.start - this.frame.end) / this.fps)  
    gsap.to(this.frame, duration, {
      current: this.frame.end,
      ease: 'Linear.easeNone',
      onUpdate: this.onUpdate,
      onComplete: onComplete
    })
  } 

  onUpdate = () => {
    this.gotoAndStop(Math.round(this.frame.current))
  }

  getFrame(frame) {
    if(typeof frame === "number"){
      return this.config.spritesheet.frames[frame]
    } else if (typeof frame === "string") {
      return findWhere(this.config.spritesheet.frames,  {filename: frame})
    }
  }

}

Sprite.Events = Events

export default Sprite